import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealPropertyToolbarModule } from '@modules/real-property-toolbar/real-property-toolbar.module';
import { VideoPlayerModule } from '@modules/video-player/video-player.module';
import { VideoModule } from '@modules/video/video.module';
import { SharedModule } from '@shared/shared.module';

import { components } from './components';
import { InitialsPipe } from '@helpers/initials.pipe';

@NgModule({
  declarations: [...components, InitialsPipe],
  imports: [CommonModule, SharedModule, RealPropertyToolbarModule, VideoModule, VideoPlayerModule],
  exports: [...components, RealPropertyToolbarModule, InitialsPipe],
})
export class SharedRealPropertyModule {}
